function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgCloudPaas(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M60 11.999c-15.673 0-28.998 10.02-33.942 24H24C10.746 35.999 0 46.744 0 60c0 13.255 10.746 24.001 24.001 24.001l.077-.002H60c19.882 0 36-16.118 36-36s-16.118-36-36-36zm0 64H24c-8.836 0-16-7.163-16-16s7.164-16 16-16h8.298c1.942-13.566 13.599-24 27.702-24 15.464 0 28 12.536 28 28s-12.536 28-28 28z"
  }), React.createElement("path", {
    d: "M67.5 59a4.5 4.5 0 000-9h-.768c-.16-1-.342-1.142-.547-1.571l.544-.668c1.757-1.757 1.757-4.669 0-6.427-1.757-1.757-4.607-1.788-6.364-.031l-.793.528c-.43-.205-.572-.403-1.572-.563V40.5a4.5 4.5 0 00-9 0v.768c0 .16-.642.342-1.071.547l-.418-.544a4.426 4.426 0 00-6.302 0c-1.757 1.757-1.726 4.607.031 6.364l.559.793c-.204.43-.371.572-.531 1.572H40.5a4.5 4.5 0 000 9h.768c.16 0 .342.642.547 1.071l-.544.418a4.426 4.426 0 000 6.302c1.757 1.757 4.607 1.726 6.364-.031l.293-.559c.43.204 1.072.371 1.072.531v.768a4.5 4.5 0 009 0v-.768c1-.16 1.142-.342 1.571-.547l.668.544c1.757 1.757 4.669 1.757 6.427 0 1.757-1.757 1.788-4.607.031-6.364l-.528-.293c.205-.43.403-1.072.563-1.072h.768zm-7.622-3.791a6.007 6.007 0 01-7.087 4.669 6.007 6.007 0 01-4.669-7.087 6.007 6.007 0 017.087-4.669 6.007 6.007 0 014.669 7.087z"
  }));
}

SvgCloudPaas.clsName = 'icon-www__cloud-paas';
SvgCloudPaas.remarkName = 'unknown';
export default SvgCloudPaas;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/CloudPaas.js
// module id = 2321
// module chunks = 17 18